import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import type { IActivityExpense } from "./types"
import api from "services/api"

export function useActivityExpensesTracking(
  params?: any,
  config?: UseQueryOptions<IActivityExpense[]>
) {
  return useQuery<IActivityExpense[]>(
    ["a-suite", "finance", "pb-actual-expense-entries", params],
    {
      keepPreviousData: true,
      ...config,
    }
  )
}

export function useActivityExpenseTracking(
  expenseId: string,
  config?: UseQueryOptions<IActivityExpense>
) {
  return useQuery<IActivityExpense>(
    ["a-suite", "finance", "pb-actual-expense-entries", expenseId],
    config
  )
}

export function useCreateActivityExpense(
  config?: UseMutationOptions<unknown, unknown, FormData>
) {
  const queryClient = useQueryClient()
  return useMutation(
    (data) => api.post(`a-suite/finance/pb-actual-expense-entries`, data),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.invalidateQueries([
          "a-suite",
          "finance",
          "pb-actual-expense-entries",
        ])
      },
    }
  )
}

export function useUpdateActivityExpense(
  expenseId: string,
  config?: UseMutationOptions<unknown, unknown, FormData>
) {
  const queryClient = useQueryClient()
  return useMutation<unknown, unknown, FormData>(
    (data) =>
      api.post(`a-suite/finance/pb-actual-expense-entries/${expenseId}`, data),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.invalidateQueries([
          "a-suite",
          "finance",
          "pb-actual-expense-entries",
        ])
      },
    }
  )
}
